var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetAsDefaultEntityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6511_76461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2663 14.5367C10.6577 14.8977 10.6704 15.5121 10.2939 15.8887L7.87704 18.3056C7.41943 18.7632 6.80188 19.0257 6.15485 19.0376L5.81304 19.0438L5.81925 18.702C5.83106 18.0548 6.09354 17.4375 6.55122 16.9798L8.96808 14.5629C9.32374 14.2075 9.89656 14.1958 10.2663 14.5367Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5959 10.0292C20.1718 9.56199 20.2166 8.69901 19.6922 8.17463L16.6818 5.16426C16.1575 4.63989 15.2945 4.68471 14.8273 5.2606L12.2678 8.41528C12.1835 8.51922 12.068 8.59335 11.9384 8.62674L6.87273 9.93187C6.40422 10.0526 6.24462 10.6369 6.58672 10.979L13.8774 18.2698C14.2195 18.6119 14.8039 18.4523 14.9246 17.9838L16.2297 12.9181C16.2631 12.7885 16.3373 12.673 16.4412 12.5887L19.5959 10.0292Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6511_76461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetAsDefaultEntityIcon);
export default __webpack_public_path__ + "static/media/set-as-default-entity-icon.f061584904ac797c9b0e9f3d045b2c44.svg";
export { ForwardRef as ReactComponent };